import styled from 'styled-components';

// Example of use. Delete if not needed.
export const SDiv = styled.div`
  display: flex;
  margin-bottom: 5px;
`;

export const SText = styled.p`
  margin: ${props => (props.isIconSVG == true ? 'auto 0 auto 10px' : 0)};
`;
